import { createFileRoute } from '@tanstack/react-router';

import { DmaAssessmentStepPage } from '@/features/esg/dma/components/DmaAssessmentStepPage';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/$assessmentId/assessment')({
  component: DmaAssessmentStepRoute,
});

function DmaAssessmentStepRoute() {
  const { assessmentId } = Route.useParams();
  return <DmaAssessmentStepPage assessmentId={assessmentId} />;
}
